import React from 'react';

import ShieldIcon from '@atlaskit/icon/core/shield';

export const DataProtectionIconV2 = (): React.JSX.Element => (
	<ShieldIcon label="" spacing="spacious" />
);
